export default __webpack_public_path__ + "static/media/TV_Icon2.f28de5b0.png";